import React from 'react';

const Header = ({ theme, toggleTheme, scrollToSection }) => {
  return (
    <header>
      <div className="container">
        <div className="header-content">
          <div className="logo" onClick={() => scrollToSection('hero')}>
            IDHO<span>MANAGEMENT</span>
          </div>
          <button className="theme-toggle" onClick={toggleTheme}>
            <i className="fas fa-sun"></i>
            <i className="fas fa-moon"></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
